import React from "react";
import { Card } from "react-bootstrap";

const ActuatorHealth = ({ health }) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header>
        <Card.Title>Actuator Status</Card.Title>
      </Card.Header>
      <Card.Body>
        <div className="d-flex justify-content-center align-items-center">
          <div
            className={`circle ${
              health === "UP"
                ? "pulse green"
                : health === "DOWN"
                ? "red"
                : "blue"
            }`}
            style={{
              width: "25px",
              height: "25px",
            }}
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default ActuatorHealth;
